export default __webpack_public_path__ + "static/media/AndrewYuan.7dbfe3cf.png";